// @flow
import React from "react";
import type { Node } from "react";
import { useSelector } from "react-redux";

// $FlowIgnore
import SubNavigation from "../SubNavigation/SubNavigation";
import { updateNavAuthedAttributes } from "./updateNavAuthedAttributes";
import type { State as MeState } from "Redux/modules/me/meReducer";
import type { State } from "Redux/modules/reducer";

const Header = (): Node => {
  const showSubmenu = useSelector(
    (state: State): boolean => state.app.showHeaderSubmenu
  );
  // $FlowIgnore
  const user = useSelector((state: State): MeState => state.me.user);

  React.useEffect(() => {
    if (!!user?.name) {
      updateNavAuthedAttributes(
        `${user.name} ${user.surname}`,
        user?.memberNumber,
        user?.subscriptionLevel && user.subscriptionLevel !== "null"
          ? user.subscriptionLevel
          : "free",
        !!user?.instructor?.number,
        user?.subscriptionType || "group-membership"
      );
    }
  }, [user]);

  return (
    <>
      {/* eslint-disable-next-line react/self-closing-comp */}
      <delta-nav></delta-nav>
      {showSubmenu && <SubNavigation isAuthed={!!user?.name} />}
    </>
  );
};

export default Header;
